import React from "react";
import { useState, useEffect } from "react";
import cn from "classnames";
import LinkIcon from "./link.svg";
import Succes from "./succesSVG";
import styles from "./styles.module.scss";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { track } from "../../../utils/amplitude";

const CopyLinkButton = ({ props }) => {
  const [location, setLocation] = useState(null);
  const { data } = props;
  const [click, setClick] = useState(false);
  useEffect(() => {
    if (click) setTimeout(() => setClick(false), 2000);
  }, [click]);

  useEffect(() => {
    setLocation(window.location.href);
  }, []);

  return (
    <div className={styles.actions}>
      <CopyToClipboard
        text={location}
        onCopy={() => {
          track("paywall_gallery_item_copy_link_clicked");
          setClick(true);
        }}
      >
        <span className={cn(styles.copise, click && styles.copiseDown)}>
          <LinkIcon />
          &nbsp;Copy the link to the screen{" "}
        </span>
      </CopyToClipboard>
      <span className={cn(styles.copiSuccess, click && styles.copiSuccessUp)}>
        <Succes />
        &nbsp;Link copied successfull{" "}
      </span>
    </div>
  );
};

export default CopyLinkButton;
